module.exports = __webpack_public_path__ + "img/portrait-002.d9ba549e.jpg";